import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';

import HeroContent from './HeroContent';
import Section from '../../common/Section';
import Anchor from '../utils/Anchor';
import { getBackgroundImage } from '../heroBlock/Hero';

const Wrapper = styled(Section)`
  padding-right: 0;
  padding-left: 0;
  padding-top: 2rem;

  ${media.mediumLarge`
    padding-right: ${props => (props.blockAlignment === 'Right' ? 0 : 'var(--padding-m)')};
    padding-left: ${props => (props.blockAlignment === 'Left' ? 0 : 'var(--padding-m)')};
  `}

  ${media.large`
    padding-right: ${props => (props.blockAlignment === 'Right' ? 0 : 'var(--padding-l)')};
    padding-left: ${props => (props.blockAlignment === 'Left' ? 0 : 'var(--padding-l)')};
  `};

  .video {
    width: 100%;
    height: 500px;

    ${media.large`
      height: 750px;
    `}
  }
`;

const ContentWrapper = styled.div`
  background-image: ${props => getBackgroundImage(props)};
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 500px;
  margin: 0 auto;
  padding-top: 180px;
  padding-bottom: 6rem;
  padding-left: 1rem;
  padding-right: 1rem;
  ${media.mediumLarge`
    padding-left: 50%;
    padding-right: 2rem;
  `}
  ${media.large`
    background-position: 0%;
    flex-direction: row;
    align-items: center;
    height: 750px;
    padding-top: 300px;
  `}
`;

class VideoBlock extends React.Component {
  state = {
    showIframe: false,
  };

  onClick = () => {
    this.setState({ showIframe: true });
  };

  renderYoutubeIframe() {
    const { videoId, name } = this.props.content.video.fields;
    const options = 'controls=1&autoplay=1';
    const src = `https://www.youtube.com/embed/${videoId}?${options}`;

    return (
      <iframe
        src={src}
        className="video"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={name}
      />
    );
  }

  render() {
    const { blockAlignment, blockId } = this.props.content;
    return (
      <React.Fragment>
        <Anchor id={blockId} />
        <Wrapper blockAlignment={blockAlignment}>
          {this.state.showIframe ? (
            this.renderYoutubeIframe()
          ) : (
            <ContentWrapper
              imgSmallWebP={this.props.content.backgroundImageSmallWebP}
              imgLargeWebP={this.props.content.backgroundImageLargeWebP}
              imgSmall={this.props.content.backgroundImageSmall}
              imgLarge={this.props.content.backgroundImageLarge}
            >
              <HeroContent content={this.props.content} onClick={this.onClick} />
            </ContentWrapper>
          )}
        </Wrapper>
      </React.Fragment>
    );
  }
}

VideoBlock.propTypes = {
  content: PropTypes.object,
};

export default VideoBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/videoBlock/VideoBlock.js